import React from 'react';

import { EQuantityFormatKey } from '../../../StoreSettings.types';
import {
  ABBREVIATION_DROPDOWN_FIELDS,
  ABBREVIATION_TOGGLE_FIELDS
} from '../AbbreviationsSettingsV2.consts';
import {
  QuantityFieldPath,
  QuantityFieldValue
} from '../AbbreviationsSettingsV2.types';

import { AbbreviationToggleCard } from './AbbreviationToggleCard';
import { QuantityFormatDropdownField } from './QuantityFormatDropdownField';
import { ShowFullNumberField } from './ShowFullNumberField';

interface IQuantityFormatPanelProps {
  sectionKey: EQuantityFormatKey;
  onCommit: (path: QuantityFieldPath, value: QuantityFieldValue) => void;
}

export const QuantityFormatPanel = ({
  sectionKey,
  onCommit
}: IQuantityFormatPanelProps): React.ReactElement => (
  <div className="flex flex-col gap-[30px]">
    <div className="flex gap-[15px]">
      {ABBREVIATION_DROPDOWN_FIELDS.map((field) => (
        <div key={field.key} className="flex-1">
          <QuantityFormatDropdownField
            sectionKey={sectionKey}
            field={field}
            onSelect={onCommit}
          />
        </div>
      ))}
    </div>
    <ShowFullNumberField sectionKey={sectionKey} onCommit={onCommit} />
    <div className="grid grid-cols-4 gap-4">
      {ABBREVIATION_TOGGLE_FIELDS.map((field) => (
        <AbbreviationToggleCard
          key={field.key}
          sectionKey={sectionKey}
          field={field}
          onToggle={onCommit}
        />
      ))}
    </div>
  </div>
);
